import { createDashboardReduxModule } from 'utils/reduxDashboardModuleCreator'

export const urgentUnclassifiedIncidentsRedux = createDashboardReduxModule({
  name: 'URGENT_UNCLASSIFIED_INCIDENTS_WIDGET',
  path: 'dashboard/home/urgentUnclassifiedIncidents',
})
export const SET_END_USER_FILTER = 'SET_END_USER_FILTER'

export const selectEndUserFilter = (state) =>
  state.dashboard.home.urgentUnclassifiedIncidents.endUserFilter
